// import services from '@/services/index';

export default function helpersFactory(services) {
  return {
    init,
    set,
    get,
    copyObject,
    hasValue,
    isEmpty,
  };

  ////////////////////
  function init() {
  }

  function set(obj, path, value) {
    if (!path) {
      return obj;
    }

    let split = path.split('.');
    if (split.length > 1) {
      obj[split[0]] = obj[split[0]] ? obj[split[0]] : {};
      let p1 = split.shift();
      set(obj[p1], split.join('.'), value);
    }
    else {
      obj[split[0]] = value;
    }
  }

  function get(obj, path, value) {
    if (!path) {
      return value;
    }

    let split = path.split('.');
    let myObj = obj;
    for (let i = 0; i < split.length; i++) {
      myObj = myObj[split[i]];
      if (!myObj) {
        break;
      }
    }

    return myObj ? myObj : value;
  }

  function copyObject(object) {
    return object ? JSON.parse(JSON.stringify(object)) : null;
  }

  function hasValue(item) {
    return item === undefined || item === null;
  }

  function isEmpty(item) {
    return item === undefined || item === null || item.trim() === '';
  }

}
